import React, { Component } from "react";
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.min.css';
import Iframes from '../Iframes/Iframes';
import { CVistaPrincipalVideos_ } from '../../services/WebAPI_Utrahuilca';
import AOS from 'aos';
import 'aos/dist/aos.css';

class AperturaProducto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videos: [],
            resultado: false
        };
    }

    async componentDidMount() {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: false,
        });
        this.cargarInfNuestAsociados();
    }

    cargarInfNuestAsociados = () => {
        const { idprodutra } = this.props;

        const data = {
            //tran: 6,
            tran: 7,
            idprincvid: idprodutra,  // SE REUTILIZA idprincvid PARA ENVIAR idprodutra
            titulovid: 'N/A',
            enlacevid: 'N/A',
            estadovid: 1,
            usuario: 0
        }

        CVistaPrincipalVideos_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    this.setState({ videos: response.data, resultado: true });
                } else {
                    this.setState({ videos: [], resultado: false });
                }
            } catch (error) {
                console.log('Sin registro de videos');
            }
        });
    }

    render() {
        const params = {
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            }
        }
        return (
            <>
                <div style={{ width: '100%', paddingTop: '20px', paddingBottom: '30px' }}>
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        <h2 data-aos="fade-up" style={{ fontWeight: 'bold', marginBottom: '10px', fontSize: '24px' }}>
                            ¿Cómo abrir tu Ahorro Digital?
                        </h2>

                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '20px' }}>
                            <div style={{ height: '4px', backgroundColor: '#007c89', borderRadius: '2px', width: '60px' }}></div>
                            <div style={{ height: '4px', backgroundColor: '#007c89', borderRadius: '2px', width: '30px' }}></div>
                        </div>

                        <p data-aos="fade-up" style={{ fontSize: '16px', color: '#333', marginBottom: '30px' }}>
                            Para abrir en línea un Ahorro Digital, debes ser asociado de <strong>UTRAHUILCA</strong> mayor de 18 años.
                        </p>

                        <React.Fragment>
                            <div data-aos="fade-up" className="mb-2 pb-2" style={{ width: '100%', display: 'flex', justifycontent: 'center' }}>
                                <div className="container">
                                    {this.state.resultado ? (<React.Fragment>
                                        <Swiper {...params} className="rounded pb-5">
                                            {this.state.videos.map((e, i) => {
                                                return [
                                                    <div className="d-flex justify-content-center">
                                                        <Iframes ancho={'1080px'} alto={'500px'}  url={e.enlacevideo} />
                                                    </div>
                                                ];
                                            })}
                                        </Swiper>
                                    </React.Fragment>) : (<React.Fragment></React.Fragment>)}
                                </div>
                            </div>
                        </React.Fragment>
                    </div>
                </div>
            </>
        );
    }
}

export default AperturaProducto;